import { Component, Inject, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ControlBase } from '../../base/control-base/control-base.component';
import { ExtendedFormGroup } from '../../../base-classes/extended-form-group.class';
import { Validators } from '@angular/forms';
import { TextareaControl } from '../../../base-classes/form-field-classes/textarea-control.class';
import { SuggestionModel } from '../../../types/suggestion.model';
import { firstValueFrom } from 'rxjs';
import { CoreService_TOKEN } from '../../../tokens/injection-tokens';
import { ICoreService } from '../../../interfaces/core-service.interface';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'suggestion-control',
    templateUrl: 'suggestion.control.html',
    standalone: false,
})
export class SuggestionControl extends ControlBase implements OnInit {
    constructor(
        @Inject(CoreService_TOKEN)
        private coreService: ICoreService,
        protected override spinnerService: NgxSpinnerService
    ) {
        super(spinnerService);
    }

    public suggestionForm: ExtendedFormGroup<String>;

    public ngOnInit(): void {
        this.initFormGroup();
    }

    private initFormGroup() {
        this.suggestionForm = new ExtendedFormGroup('suggestion-form', String, {
            suggestionText: new TextareaControl('suggestionText', '', [Validators.required]),
        });
    }

    public saveSuggestion = async (): Promise<any> => {
        if (this.suggestionForm.validateAllFormFields()) {
            let model: SuggestionModel = new SuggestionModel();
            model.suggestionText = this.suggestionForm.getControlValue('suggestionText');
            model.extensionName = this.settings.applicationName;

            return this.handleSpinner(
                firstValueFrom(this.coreService.saveSuggestion(model))
                    .then(res => {
                        this.initFormGroup();
                        this.ioc.core.notificationService.createSuccessTranslateMessage('suggestion.save_success');
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.ioc.core.notificationService.createDangerTranslateMessage('suggestion.save_failed');
                    })
            );
        }
    };
}
